import { render, staticRenderFns } from "./TransactionDetailWrapper.vue?vue&type=template&id=0bad0308&scoped=true&"
import script from "./TransactionDetailWrapper.vue?vue&type=script&lang=js&"
export * from "./TransactionDetailWrapper.vue?vue&type=script&lang=js&"
import style0 from "./TransactionDetailWrapper.vue?vue&type=style&index=0&id=0bad0308&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bad0308",
  null
  
)

export default component.exports